import State from '../core/State';
import initialState from '../initialState';
import { Organization } from '@kaizenplatform/intelligence-entity';
import produce, { Draft } from 'immer';

export const startFetchingLastAccessedOrganization = () =>
  produce((draft: Draft<State>) => {
    draft.lastAccessedOrganization.fetching = draft.lastAccessedOrganization.fetching + 1;
  });

export const finishFetchingLastAccessedOrganization = () =>
  produce((draft: Draft<State>) => {
    draft.lastAccessedOrganization.fetching = draft.lastAccessedOrganization.fetching - 1;
  });

export const setLastAccessedOrganization = (organization: Organization) =>
  produce((draft: Draft<State>) => {
    draft.lastAccessedOrganization.item = organization;
  });

export const disposeLastAccessedOrganization = () =>
  produce((draft: Draft<State>) => {
    draft.lastAccessedOrganization = initialState.lastAccessedOrganization;
  });
